module.exports = __webpack_public_path__ + "static/media/SecondaryAutomation.532b860a.webp";